<template>
	<v-container>
		<ForgotPassword/>
	</v-container>
</template>

<script>
import ForgotPassword from '@/components/ForgotPassword.vue';

export default {
  name: 'ForgotPasswordPage',
  
  components: {
    ForgotPassword
  },

  data() {
    return {
    };
  },
  computed: {
  },
  created() {
    
  },
  mounted() {
  },
  methods: {
  }
};
</script>